import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock, TrendingUp, ShieldCheck } from "lucide-react";
import PageHero from "../components/common/PageHero";
import { Reveal } from "../components/common/Section";
import { Button } from "../components/ui/button";
import RoiCalculator from "../components/governance/RoiCalculator";

const STEPS = [
  { icon: Clock, title: "Enter your estate", desc: "Monthly conversation volume, how much you screen today and your review effort." },
  { icon: TrendingUp, title: "See the business case", desc: "Hours saved, illustrative cost avoided and the coverage gap you could close." },
  { icon: ShieldCheck, title: "Take it to your board", desc: "Download a branded PDF or have the summary emailed to you." },
];

export default function RoiCalculatorPage() {
  useEffect(() => { document.title = "ROI & Value Calculator | norse3"; }, []);

  return (
    <div>
      <PageHero
        eyebrow="ROI & value calculator"
        title="Build the business case for AI governance."
        subtitle="Model the hours saved and the coverage you could gain by screening more of your regulated conversations. Adjust the inputs to your estate and download a board-ready summary. Illustrative only — not a guarantee of savings."
      />

      <section className="py-12 lg:py-16">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <Reveal>
            <div className="grid gap-4 sm:grid-cols-3 mb-10">
              {STEPS.map((s) => {
                const Icon = s.icon;
                return (
                  <div key={s.title} className="rounded-lg border border-border bg-card p-6">
                    <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-primary/12 text-primary"><Icon className="h-5 w-5" /></span>
                    <h3 className="mt-4 text-base font-semibold text-foreground">{s.title}</h3>
                    <p className="mt-1.5 text-sm text-muted-foreground">{s.desc}</p>
                  </div>
                );
              })}
            </div>
          </Reveal>

          <Reveal delay={80}>
            <RoiCalculator />
          </Reveal>

          <Reveal delay={120}>
            <div className="mt-12 rounded-xl border border-border bg-muted/40 p-8 lg:p-10 text-center">
              <h2 className="text-2xl font-bold text-foreground">Want the full governance picture?</h2>
              <p className="mt-3 text-muted-foreground max-w-2xl mx-auto">Pair this business case with a readiness assessment, policy sandbox and framework mapping in the free Governance Tools suite.</p>
              <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
                <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90"><Link to="/governance-tools" data-testid="roi-to-gov-tools">Open Governance Tools <ArrowRight className="ml-1.5 h-4 w-4" /></Link></Button>
                <Button asChild variant="outline" className="border-border bg-transparent hover:bg-muted/60 text-foreground"><Link to="/book-a-demo" data-testid="roi-to-book">Book a walkthrough</Link></Button>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
